import React from "react";

const UniversalPagination = ({
    currentPage,
    totalPages,
    totalItems,
    startItem,
    endItem,
    visiblePages,
    onPageChange,
    onPrevious,
    onNext,
    hasPreviousPage,
    hasNextPage,
}) => {
    if (totalItems === 0) return null;

    return (
        <div className="card-header d-flex justify-content-between gap-3">
            <div className="col-sm-12 col-md-5">
                <div
                    className="dataTables_info"
                    role="status"
                    aria-live="polite"
                >
                    Mostrando {startItem} de {endItem} de {totalItems} entradas
                </div>
            </div>

            <div className="col-sm-12 col-md-7">
                <div className="dataTables_paginate paging_simple_numbers">
                    <ul className="pagination justify-content-md-end">
                        <li
                            className={`paginate_button page-item previous ${
                                !hasPreviousPage ? "disabled" : ""
                            }`}
                        >
                            
                            <a class="page-link" aria-label="Previous" onClick={onPrevious} disabled={!hasPreviousPage}>
                                <span aria-hidden="true">«</span>
                            </a>
                        </li>

                        {visiblePages.map((page) => (
                            <li
                                key={page}
                                className={`paginate_button page-item ${
                                    currentPage === page ? "active" : ""
                                }`}
                            >
                                <button
                                    type="button"
                                    className="page-link"
                                    onClick={() => onPageChange(page)}
                                >
                                    {page}
                                </button>
                            </li>
                        ))}

                        <li
                            className={`paginate_button page-item next ${
                                !hasNextPage ? "disabled" : ""
                            }`}
                        >
                            <a class="page-link" href="#" aria-label="Next" onClick={onNext} disabled={!hasNextPage}>
                                <span aria-hidden="true">»</span>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default UniversalPagination;